var map = {
	"./ca-AD.json": "7085",
	"./ca-ES.json": "f725",
	"./en-US.json": "e0e1",
	"./es-AR.json": "58dd",
	"./es-CL.json": "cdc3",
	"./es-CO.json": "54af",
	"./es-ES.json": "4109",
	"./es-MX.json": "538b",
	"./eu-ES.json": "8bb1",
	"./fr-FR.json": "cfe4",
	"./it-IT.json": "bf7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "231a";